import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { FAQTheme } from 'modules/theme';

export class FAQ extends React.Component {
  render() {
    return (
      <FAQTheme 
        title={'FAQs'}
        search={''}
        btnSearch={'images/search.svg'}
        q1={`What Do Call Centers Call?`}
        a1={`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s`}
      />
    )
  }
}

FAQ.propTypes = {
};

FAQ.contextTypes = {
  __: PropTypes.func
};

export default FAQ


// WEBPACK FOOTER //
// src/dialpad/components/layout/FAQ.js